import { useEffect, useMemo } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import UniversalRecordTable from '../../components/Tables/universalRecord/UniversalRecordTable';
import { useCashRegister } from '../../hooks/cash/useCashRegister';
import { cashRegisterColumns } from '../../features/cash/cashRegisterColumns';
import CashRegisterCreatePopup from '../../components/Cash/Register/CashRegisterCreatePopup';
import CashRegisterEditPopup from '../../components/Cash/Register/CashRegisterEditPopup';
import CashRegisterViewPopup from '../../components/Cash/Register/CashRegisterViewPopup';

const CashRegistersPage: React.FC = () => {

  const {
    list,
    selected,

    fetchRegisters,
    deactivateRegister,
    selectRegister,

    openCreate,
    closeCreate,
    showCreateModal,

    openEdit,
    closeEdit,
    showEditModal,

    openView,
    closeView,
    showViewModal

  } = useCashRegister();

  useEffect(() => {
    fetchRegisters();
  }, []);

  const columns = useMemo(() => cashRegisterColumns, []);

  const getActions = (row: any) => {

    const actions = [

      {
        key: 'view',
        label: 'Ver',
        onClick: () => {
          selectRegister(row);
          openView();
        },
      },

      {
        key: 'edit',
        label: 'Editar',
        onClick: () => {
          selectRegister(row);
          openEdit();
        },
      },

      {
        key: 'cancel',
        label: 'Desactivar',
        onClick: () => deactivateRegister(row.id),
      },

    ];

    return actions;
  };

  return (
    <DefaultLayout>

      <BreadcrumbTwo />

      <UniversalRecordTable
        columns={columns}
        data={list}
        getActions={getActions}
        enableRowClick={true}
        showPagination={false}
        noDataMessage="No hay terminales POS registradas."
        topRightAction={{
          label: 'Nueva Terminal POS',
          onClick: openCreate,
        }}
      />

      {/* CREATE */}
      <CashRegisterCreatePopup
        isOpen={showCreateModal}
        onClose={closeCreate}
      />

      {/* EDIT */}
      <CashRegisterEditPopup
        isOpen={showEditModal}
        onClose={closeEdit}
        registerId={selected?.id ?? null}
      />

      {/* VIEW */}
      <CashRegisterViewPopup
        isOpen={showViewModal}
        onClose={closeView}
      />

    </DefaultLayout>
  );
};

export default CashRegistersPage;